import {CustomerService} from "./service/api/customer.service";
import {CustomerRepresentativeService} from "./service/api/customer-representative/customer-representative.service";
import {
    CustomerRepresentativeTypeService
} from "./service/api/customer-representative-type/customer-representative-type.service";
import {LifeSituationService} from "./service/api/life-situation.service";
import {CustomerLifeSituationService} from "./service/api/customer-life-situation.service";
import {ConsultationGuideService} from "./service/api/consultation-guide.service";
import {ConsultationGuideVariableMappingService} from "./service/api/consultation-guide-variable-mapping.service";
import {ProfessionInsuranceRecommendationService} from "./service/api/profession-insurance-recommendation.service";
import {LifeSituationInsuranceRecommendationService} from "./service/api/life-situation-insurance-recommendation.service";
import {CustomerRecommendationService} from "./service/api/customer-recommendation.service";
import {CustomerAddressService} from "./service/api/customer-address.service";
import {CustomerCommentService} from "./service/api/customer-comment.service";
import {CustomerContactService} from "./service/api/customer-contact.service";
import {CustomerInsurableObjectService} from "./service/api/customer-insurable-object.service";
import {CustomerPhoneContactAvailabilityService} from "./service/api/customer-phone-contact-availability.service";
import {CustomerInteractionService} from "./service/api/customer-interaction.service";
import {CustomerUserService} from "./service/api/customer-user.service";
import {CustomerChannelService} from "./service/api/customer-channel.service";
import {CustomerExternalAliasService} from "./service/api/customer-external-alias.service";
import {CustomerContractService} from "./service/api/customer-contract.service";
import {CustomerEmergencyContactService} from "./service/api/customer-emergency-contact.service";
import {CustomerDetailService} from "./service/api/customer-detail.service";
import {CustomerRelatedPersonService} from "./service/api/customer-related-person.service";
import {CustomerTagService} from "./service/api/customer-tag.service";
import {CustomerBankAccountService} from "./service/api/customer-bank-account.service";
import {ENTITY_SERVICE_REGISTRY} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    CrCustomerInsurableObjectObjectComponent
} from "./component/object-components/cr-customer-insurable-object-object-component/cr-customer-insurable-object-object.component";
// cr -> ci is the established, allowed import direction (only ci -> cr is forbidden, GC1).
import {
    CiCustomerInsurableObjectCreateComponent
} from "../ci/component/protected-components/ci-customer-insurable-object-create-component/ci-customer-insurable-object-create.component";
import {CrCustomerComponent} from "./component/protected-components/cr-customer/cr-customer.component";
import {
    CrCreateObjectCustomerComponent
} from "./component/protected-components/cr-create-object-customer/cr-create-object-customer.component";
import {
    CrCustomerInteractionObjectComponent
} from "./component/protected-components/cr-customer-interaction-object-component/cr-customer-interaction-object.component";
import {
    CrCreateEmergencyContactComponent
} from "./component/protected-components/cr-customer/component/cr-create-emergency-contact/cr-create-emergency-contact.component";
import {
    MvsCustomerPhoneContactAvailabilityComponent
} from "../../core/shared/components/mvs-customer-phone-contact-availability/mvs-customer-phone-contact-availability.component";
import {
    CustomerFormTypeObjectComponent
} from "./component/protected-components/object-component/customer-form-type-object-component/customer-form-type-object.component";

export const CR_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['cr.Customer', {
                route: '/cr/customers',
                objectRoute: '/cr/customers/:id',
                service: CustomerService,
                objectComponent: [
                    {mode: MvsCrudModeEnum.create, component: CrCreateObjectCustomerComponent},
                    {component: CrCustomerComponent},
                ]
            }],
            ['cr.CustomerAddress', {route: '/cr/customerAddresses', service: CustomerAddressService}],
            ['cr.CustomerComment', {route: '/cr/customerComments', service: CustomerCommentService}],
            ['cr.CustomerAgent', {route: '/cr/customerAgents'}],
            ['cr.CustomerContact', {route: '/cr/customerContacts', service: CustomerContactService}],
            // Both modes REPLACED (design 15.5): create is the guided ci create component, update is
            // the new object component. This registry entry supersedes the former service override
            // on CustomerInsurableObjectService, which pointed both modes at the two cm components -
            // MvsCoreService.getObjectComponent:188-200 consults the registry FIRST (gate condition
            // GC8). The old wizard stays registered for ci.ContractInsurableObject.
            //
            // mode = null RESOLVES TO THE GENERIC FORM, exactly as before: both mappings carry an
            // explicit mode, so resolveComponentMapping:41-64 finds no unconditional default and the
            // call falls through to the base MvsCrudService.getObjectComponent (:73-75, returns
            // null). The removed override behaved identically for null - its `mode = update` default
            // parameter does NOT apply to an explicitly passed null. The only host passing null is
            // the routed ObjectPageComponent:193, and no route opens cr.CustomerInsurableObject.
            //
            // CAUTION, known host trap: MvsWidgetListDataExpandableComponent.showObject
            // (:228-245) opens mode=create even for an EXISTING row id. That resolves to the create
            // component below, which detects the contradiction and says so instead of silently
            // pretending to edit - see CiCustomerInsurableObjectCreateComponent
            // .isCreateModeWithExistingObject.
            ['cr.CustomerInsurableObject', {
                route: '/cr/customerInsurableObjects',
                service: CustomerInsurableObjectService,
                objectComponent: [
                    {mode: MvsCrudModeEnum.create, component: CiCustomerInsurableObjectCreateComponent},
                    {mode: MvsCrudModeEnum.update, component: CrCustomerInsurableObjectObjectComponent}
                ]
            }],
            ['cr.CustomerInsurance', {route: '/cr/customerInsurances'}],
            ['cr.CustomerType', {route: '/cr/customerTypes'}],
            ['cr.CustomerInteractionType', {route: '/cr/config?navItem=cr.CustomerInteraction'}],
            ['cr.CustomerInteractionTypeInfoStep', {route: '/cr/customerInteractionTypeInfoSteps'}],
            ['cr.CustomerPhoneContactAvailability', {route: '/cr/customerPhoneContactAvailabilitys', service: CustomerPhoneContactAvailabilityService, objectComponent: [{component: MvsCustomerPhoneContactAvailabilityComponent}]}],
            ['cr.CustomerInteractionDocument', {route: '/cr/customerInteractionDocuments'}],
            ['cr.CustomerFormField', {route: '/cr/customerFormFields'}],
            ['cr.CustomerEmail', {route: '/cr/customerEmails'}],
            ['cr.CustomerInteraction', {route: '/cr/customerInteractions', service: CustomerInteractionService, objectComponent: [{component: CrCustomerInteractionObjectComponent}]}],
            ['cr.CustomerUser', {route: '/cr/customerUsers', service: CustomerUserService}],
            ['cr.CustomerAutopilot', {route: '/cr/customerAutopilots'}],
            ['cr.CustomerEmergencyContactRelatedPerson', {route: '/cr/customerEmergencyContactRelatedPersons'}],
            ['cr.CustomerChannel', {route: '/cr/customerChannels', service: CustomerChannelService}],
            ['cr.CustomerSuperContactRelatedPerson', {route: '/cr/customerSuperContactRelatedPersons'}],
            ['cr.CustomerConsultingType', {route: '/cr/customerConsultingTypes'}],
            ['cr.CustomerExternalAlias', {route: '/cr/config?navItem=cr.CustomerAlias', service: CustomerExternalAliasService}],
            ['cr.CustomerSignature', {route: '/cr/customerSignatures'}],
            ['cr.CustomerContract', {route: '/cr/customerContracts', service: CustomerContractService}],
            ['cr.ProfileCheckCompletenessRange', {route: '/cr/profileCheckCompletenessRanges'}],
            ['cr.CustomerEmergencyContact', {route: '/cr/customerEmergencyContacts', service: CustomerEmergencyContactService, objectComponent: [{mode: MvsCrudModeEnum.create, component: CrCreateEmergencyContactComponent}]}],
            ['cr.CustomerLifestyle', {route: '/cr/customerLifestyles'}],
            ['cr.CustomerHealth', {route: '/cr/customerHealths'}],
            ['cr.CustomerPricePerformancePriority', {route: '/cr/customerPricePerformancePrioritys'}],
            ['cr.CustomerInsuranceAim', {route: '/cr/customerInsuranceAims'}],
            ['cr.CustomerBudgetInsurance', {route: '/cr/customerBudgetInsurances'}],
            ['cr.CustomerDetail', {route: '/cr/customerDetails', service: CustomerDetailService}],

            ['cr.RestrictedCustomerUnlockLog', {route: '/cr/restrictedCustomerUnlockLogs'}],
            ['cr.CustomerSepaMandateSource', {route: '/cr/customerSepaMandateSources'}],

            ['cr.CustomerForm', {route: '/cr/customerForms'}],
            ['cr.CustomerFormType', {
                route: '/cr/customerFormTypes',
                objectRoute: '/cr/customerFormTypes/:id',
                objectComponent: [{component: CustomerFormTypeObjectComponent}]
            }],
            ['cr.CustomerFormTypeField', {route: '/cr/customerFormTypeFields'}],
            ['cr.CustomerFormGroup', {route: '/cr/customerFormGroups'}],
            ['cr.CustomerOnboarding', {route: '/cr/customerOnboardings'}],
            ['cr.CustomerOnboardingType', {route: '/cr/customerOnboardingTypes'}],
            ['cr.CustomerOnboardingTypeContractType', {route: '/cr/customerOnboardingTypeContractTypes'}],
            ['cr.CustomerOnboardingTypeInfoStep', {route: '/cr/customerOnboardingTypeInfoSteps'}],
            ['cr.CustomerSignatureType', {route: '/cr/customerSignatureTypes'}],
            ['cr.CustomerWelcome', {route: '/cr/customerWelcomes'}],
            ['cr.CustomerInfoPage', {route: '/cr/customerInfoPages'}],
            ['cr.CustomerRegistrationConfiguration', {route: '/cr/customerRegistrationConfigurations'}],
            ['cr.CustomerUserConfiguration', {route: '/cr/customerUserConfigurations'}],
            ['cr.CustomerNotificationType', {route: '/cr/customerNotificationTypes'}],

            // No create-mode object component on purpose: the generic object dialog hands X/Escape to no
            // close guard, so the representative wizard is entered via the customer quick actions only.
            ['cr.CustomerRepresentative', {route: '/cr/customerRepresentatives', service: CustomerRepresentativeService}],
            ['cr.CustomerRepresentativeType', {route: '/cr/customerRepresentativeTypes', service: CustomerRepresentativeTypeService}],
            ['cr.CustomerRelatedPersonType', {route: '/cr/customerRelatedPersonTypes'}],
            ['cr.CustomerRelatedPerson', {route: '/cr/customerTypes', service: CustomerRelatedPersonService}],
            ['cr.CustomerTag', {route: '/cr/customerTags', service: CustomerTagService}],
            ['cr.CustomerCategoryType', {route: '/cr/customerCategoryTypes'}],
            ['cr.CustomerBrokerPoaType', {route: '/cr/customerBrokerPoaTypes'}],
            ['cr.CustomerBrokerPoaTypeReason', {route: '/cr/customerBrokerPoaTypeReasons'}],
            ['cr.AssessmentOverwriteOption', {route: '/cr/assessmentOverwriteOptions'}],
            ['cr.AssessmentResultRange', {route: '/cr/assessmentResultRanges'}],
            ['cr.AssessmentOverwrite', {route: '/cr/assessmentOverwrites'}],

            ['cr.RoleAuthCustomerType', {route: '/cr/roleAuthCustomerTypes'}],
            ['cr.RoleAuthCustomer', {route: '/cr/roleAuthCustomers'}],
            ['cr.BusinessCustomer', {route: '/cr/businessCustomers'}],
            ['cr.CustomerBankAccount', {route: '/cr/customerBankAccounts', service: CustomerBankAccountService}],
            ['cr.RoleAuthCustomerRegion', {route: '/cr/roleAuthCustomerRegions'}],

            ['cr.ProfileCheckType', {route: '/cr/profileCheckTypes'}],
            ['cr.AssessmentGroup', {route: '/cr/assessmentGroups'}],
            ['cr.AssessmentGroupCheck', {route: '/cr/assessmentGroupChecks'}],

            ['cr.CustomerInteractionInsurableObject', {route: '/cr/customerInteractionInsurableObjects'}],
            ['cr.CustomerInteractionContract', {route: '/cr/customerInteractionContracts'}],
            ['cr.RoleAuthCustomerIndex', {route: '/cr/roleAuthCustomerIndexs'}],
            ['cr.CustomerInteractionConsultationOption', {route: '/cr/customerInteractionConsultationOptions'}],
            ['cr.CustomerOrigin', {route: '/cr/customerOrigins'}],

            ['cr.LifeSituation', {route: '/cr/config?navItem=cr.LifeSituation', service: LifeSituationService}],
            ['cr.CustomerLifeSituation', {route: '/cr/customerLifeSituations', service: CustomerLifeSituationService}],
            ['cr.ConsultationGuide', {route: '/cr/config?navItem=cr.ConsultationGuide', service: ConsultationGuideService}],
            ['cr.ConsultationGuideVariableMapping', {route: '/cr/consultationGuideVariableMappings', service: ConsultationGuideVariableMappingService}],
            ['cr.ConsultationGuideRun', {route: '/cr/consultationGuideRuns'}],
            ['cr.ProfessionInsuranceRecommendation', {route: '/cr/config?navItem=cr.ProfessionInsuranceRecommendation', service: ProfessionInsuranceRecommendationService}],
            ['cr.LifeSituationInsuranceRecommendation', {route: '/cr/lifeSituationInsuranceRecommendations', service: LifeSituationInsuranceRecommendationService}],
            ['cr.CustomerRecommendation', {route: '/cr/customerRecommendations', service: CustomerRecommendationService}],

        ],
        multi: true
    }
];
